import { BookOpen } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { LessonHistoryEntry } from '../../types/history';

interface LessonHistoryItemProps {
  lesson: LessonHistoryEntry;
}

export default function LessonHistoryItem({ lesson }: LessonHistoryItemProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }).format(date);
  };

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(date);
  };

  return (
    <div className="flex gap-4 bg-background px-4 py-3 justify-between border-b border-border-light">
      <div className="flex items-start gap-4">
        <div className="text-white flex items-center justify-center rounded bg-border shrink-0 size-12">
          <BookOpen size={24} weight="regular" />
        </div>
        <div className="flex flex-1 flex-col justify-center">
          <p className="text-white text-base font-medium leading-normal">
            {lesson.summary || `${lesson.subject} - ${lesson.topic || 'Lesson'}`}
          </p>
          <p className="text-text-secondary text-sm font-normal leading-normal">
            {lesson.subject} • {lesson.course}
          </p>
          <p className="text-text-secondary text-sm font-normal leading-normal">
            {formatDate(lesson.started_at)} at {formatTime(lesson.started_at)} 
            {lesson.ended_at ? ` • ${lesson.interaction_count} interactions` : ' • In progress'}
          </p>
        </div>
      </div>
      <div className="shrink-0">
        <Link
          to={`/history/${lesson.id}`}
          className="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded h-8 px-4 bg-border text-white text-sm font-medium leading-normal w-fit"
        >
          <span className="truncate">View</span>
        </Link>
      </div>
    </div>
  );
}
